<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.73 16.41">
    <defs>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Group_111" data-name="Group 111">
          <g id="Group_106" data-name="Group 106">
            <rect
              id="Rectangle_43"
              data-name="Rectangle 43"
              class="cls-1"
              y="3.97"
              width="11.73"
              height="1.78"
              rx="0.6"
            />
            <rect
              id="Rectangle_44"
              data-name="Rectangle 44"
              class="cls-1"
              y="7.29"
              width="11.73"
              height="1.78"
              rx="0.6"
            />
            <rect
              id="Rectangle_45"
              data-name="Rectangle 45"
              class="cls-1"
              y="10.6"
              width="11.73"
              height="1.78"
              rx="0.6"
            />
          </g>
          <g id="Group_108" data-name="Group 108">
            <g id="Group_107" data-name="Group 107">
              <path
                id="Path_57"
                data-name="Path 57"
                class="cls-1"
                d="M7.82,13.85a.3.3,0,0,1,.3.29.32.32,0,0,1-.09.23l-1.95,2a.29.29,0,0,1-.42,0h0l-1.95-2a.3.3,0,0,1,.21-.52Z"
              />
            </g>
          </g>
          <g id="Group_110" data-name="Group 110">
            <g id="Group_109" data-name="Group 109">
              <path
                id="Path_58"
                data-name="Path 58"
                class="cls-1"
                d="M7.82,2.56a.3.3,0,0,0,.3-.3A.31.31,0,0,0,8,2L6.08.09a.29.29,0,0,0-.42,0h0L3.7,2a.3.3,0,0,0,.21.52Z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
